import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { ApiMerchant } from '../models/merchant/merchant.interface';
import { environment } from '../../environments/environment'
import { tap } from 'rxjs/operators';

const { baseUrl } = environment;

@Injectable({
  providedIn: 'root'
})
export class MerchantService {
  constructor(private httpClient: HttpClient) { }

  MerchantStateMachine(authToken: string, merchantId: string): Observable<ApiMerchant> {
    const url = `${baseUrl}/merchant/${merchantId}`;

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      })
    };

    const response = this.httpClient.get<ApiMerchant>(
      url,
      httpOptions
    ).pipe(
      tap((merchantData: ApiMerchant) => {
        try {
          if(!merchantData) {
            return;
          }

          localStorage.setItem('merchant_name', merchantData.merchant_name);
          localStorage.setItem('merchant_logo', merchantData.branding.logo);

          if (merchantData.merchant_identification_number) {
            localStorage.setItem('merchant_identification_number', merchantData.merchant_identification_number);
          }

          if (
            merchantData.address &&
            merchantData.address.length > 0 &&
            merchantData.address[0].address &&
            merchantData.address[0].address_line_1
          ) {
            const { address, address_line_1, city, state } = merchantData.address[0];
            localStorage.setItem('merchant_address', address);
            localStorage.setItem('merchant_address_line', address_line_1);
            localStorage.setItem('merchant_address_city', city);
            localStorage.setItem('merchant_address_state', state);
          } else {
            console.warn('No existe address[0].address para guardar.');
          }

          if (merchantData.requires_rendition !== undefined) {
            localStorage.setItem('requires_rendition', String(merchantData.requires_rendition));
          }

          if (merchantData.dashboard_features && Array.isArray(merchantData.dashboard_features)) {
            localStorage.setItem('dashboard_features', JSON.stringify(merchantData.dashboard_features));
          }
          
        } catch (error) {
          console.error('Error en tap:', error);
        }
      })
    );
    console.log(response);
    return response;
  }

  public getMerchantAddress() {
    return {
      address: localStorage.getItem('merchant_address') ?? '',
      address_line_1: localStorage.getItem('merchant_address_line') ?? '',
      city: localStorage.getItem('merchant_address_city') ?? '',
      state: localStorage.getItem('merchant_address_state') ?? '',
    }
  }
}